import { FC, useEffect, useState } from "react";
import "./index.css"; /* Ajuste para o nome correto do seu arquivo CSS */
import InputMask from "react-input-mask";
import api from "../../../services/api";
import useAuth from "../../../hooks/useAuth";
import { usePluginspace } from "../../../hooks/usePluginspace";
import { cpfCnpjNoMask, telephoneNoMask } from "../../../functions/mask";
import Swal from "sweetalert2";
import { useNavigate, useParams } from "react-router-dom";
import { Loading } from "../../../components/Loading";
import { useAppConfig } from "../../../hooks/useAppConfig"; // Importado para pegar a cor principal

const PerfilInfo: FC = () => {
  const [maskCpfjCnpj, setmaskCpfjCnpj] = useState("999.999.999-99");
  const [maskTelephone, setMaskTelephone] = useState("(99) 99999-9999");
  const [telephone, setTelephone] = useState("");

  const [cpfCustomer, setCpfCustomer] = useState("");
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [gender, setGender] = useState("");
  const [whatsApp, setWhatsApp] = useState(false);
  const [loading, setLoading] = useState(false);

  const { loginInfo } = useAuth();
  const { getToken } = usePluginspace();
  const navigate = useNavigate();
  const { pluginspace_id } = useParams();

  // Estados para a Cor Primária
  const { getAppConfig } = useAppConfig();
  const [primaryColor, setPrimaryColor] = useState("#078BD8");

  const atualizar = async () => {
    setLoading(true);
    const update = {
      name: name,
      email: email,
      doc: cpfCnpjNoMask(cpfCustomer),
      cpf: cpfCnpjNoMask(cpfCustomer),
      gender: gender ? gender : "Não Informar",
      optinWhatsapp: whatsApp,
      phones: [
        {
          typePhone: "cell",
          numberPhone: telephoneNoMask(telephone),
        },
      ],
      addresses: [],
    };

    await api
      .post(`/api/customer`, update, {
        headers: {
          Authorization: `Bearer ${await getToken()}`,
        },
      })
      .then((response) => {
        setLoading(false);
        if (response.data.success === true) {
          Swal.fire({
            icon: "success",
            title: "Sucesso!",
            text: "Informações atualizadas com sucesso.",
            confirmButtonColor: primaryColor,
          }).then(() => {
            navigate(`/${pluginspace_id}/profile`);
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Erro!",
            text: "Falha ao atualizar dados do cliente",
            confirmButtonColor: primaryColor,
          });
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
        Swal.fire({
          icon: "error",
          title: "Erro!",
          text: "Falha ao comunicar com o servidor.",
          confirmButtonColor: primaryColor,
        });
      });
  };

  const getCustomerAndConfig = async () => {
    setLoading(true);

    try {
      // 1. Pega a cor principal
      const conf = await getAppConfig();
      if (conf?.webappcolor?.webappbutton) {
        setPrimaryColor(conf.webappcolor.webappbutton);
      }

      // 2. Busca o cliente
      if (loginInfo.identifier) {
        await api
          .post(
            `/api/customer/filter`,
            {
              cpf: loginInfo.identifier,
            },
            {
              headers: {
                Authorization: `Bearer ${await getToken()}`,
              },
            },
          )
          .then((response: any) => {
            if (response.data.data.length > 0) {
              const data = response.data.data[0];

              setCpfCustomer(data.doc);
              setName(data.name);
              setEmail(data.email);
              setGender(data.gender);
              setWhatsApp(data.optinWhatsapp);
              if (data.customerPhones && data.customerPhones.length > 0) {
                setTelephone(data.customerPhones[0].numberPhone);
              }
            }
          })
          .catch((err: any) => {
            console.log(err);
          });
      }
    } catch (error) {
      console.log(error);
    }

    setLoading(false);
  };

  useEffect(() => {
    getCustomerAndConfig();
  }, [loginInfo.identifier]);

  return (
    <>
      {loading ? (
        <div
          style={{
            width: "100%",
            height: "100%",
            position: "absolute",
            top: 0,
            left: 0,
            backgroundColor: "#FFF",
            zIndex: 10,
          }}
        >
          <Loading type="spinningBubbles" color="#FFF" width={64} height={64} />
        </div>
      ) : (
        <div className="perfil-info-content">
          <div className="perfil-info-header">
            <h2>Informações pessoais</h2>
          </div>

          <div className="perfil-info-inputs-container">
            {/* CPF */}
            <div className="perfil-info-input-group">
              <label>CPF</label>
              <InputMask
                className="perfil-info-input"
                mask={maskCpfjCnpj}
                placeholder="123.456.789-00"
                type="text"
                value={cpfCustomer}
                onChange={(event) => setCpfCustomer(event.target.value)}
                disabled
              />
            </div>

            {/* Nome */}
            <div className="perfil-info-input-group">
              <label>Nome</label>
              <input
                className="perfil-info-input"
                type="text"
                placeholder="Seu nome completo"
                value={name}
                onChange={(event) => setName(event.target.value)}
              />
            </div>

            {/* Email */}
            <div className="perfil-info-input-group">
              <label>Email</label>
              <input
                className="perfil-info-input"
                type="email"
                placeholder="exemplo@email.com"
                value={email}
                disabled
                onChange={(event) => setEmail(event.target.value)}
              />
            </div>

            {/* Telefone */}
            <div className="perfil-info-input-group">
              <label>Telefone</label>
              <InputMask
                className="perfil-info-input"
                mask={maskTelephone}
                placeholder="(DDD) 99999-9999"
                type="text"
                value={telephone}
                onChange={(event) => setTelephone(event.target.value)}
              />
            </div>

            <button
              className="perfil-info-btn"
              style={{ background: primaryColor }}
              onClick={() => atualizar()}
            >
              Atualizar
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export { PerfilInfo };
